import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloDataSource extends AloBase {  
    newId:number  
    dsoPos:number    
    dsoDbname:string 
    dsoParamJson:string
}

export const getDefaultAloDataSource = ():AloDataSource => {
    return {
        ...getDefaultAloBase(),
        newId:0,
        dsoPos:0,
        dsoDbname:'',
        dsoParamJson:'{}'
    }
}

export const cleanAloDataSource = (datasource:AloDataSource) => {
    if(!datasource) return    
    //if(!datasource.id) delete datasource.id    
}
